import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class RealTimeNotificationsConfig {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getSessionLimitNotificationTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.sessionLimitRT?.topic,
			"session-notification-"
		);
	}

	getSessionLimitNotificationsEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.sessionLimitRT?.isEnabled, false);
	}

	getSessionLimit80NotificationMessage() {
		return this.configService.get((x) => x.common.realTimeNotifications?.sessionLimitRT?.message80, "session80");
	}

	getSessionLimit100NotificationMessage() {
		return this.configService.get((x) => x.common.realTimeNotifications?.sessionLimitRT?.message100, "session100");
	}

	getResponsibleGamingNotificationTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.responsibleGamingNotificationsRT?.topic,
			"responsiblegaming-notification"
		);
	}

	getResponsibleGamingNotificationEnabled() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.responsibleGamingNotificationsRT?.isEnabled,
			false
		);
	}

	getDepositLimit80NotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.responsibleGamingNotificationsRT?.deposit80Message,
			"deposit80"
		);
	}

	getDepositLimit100NotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.responsibleGamingNotificationsRT?.deposit100Message,
			"deposit100"
		);
	}

	getNetDepositLimit100NotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.responsibleGamingNotificationsRT?.netDeposit100Message,
			"netDeposit100"
		);
	}

	getNetLossLimit80NotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.responsibleGamingNotificationsRT?.netloss80Message,
			"netloss80"
		);
	}

	getNetLossLimit100NotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.responsibleGamingNotificationsRT?.netloss100Message,
			"netloss100"
		);
	}

	getWageringLimit80NotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.responsibleGamingNotificationsRT?.wageringLimit80Message,
			"wageringLimit80"
		);
	}

	getWageringLimit100NotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.responsibleGamingNotificationsRT?.wageringLimit100Message,
			"wageringLimit100"
		);
	}

	getLossTriggerTopic() {
		return this.configService.get((x) => x.common.realTimeNotifications?.lossTriggerRT?.topic, "loss-trigger");
	}

	getLossTriggerMessage() {
		return this.configService.get((x) => x.common.realTimeNotifications?.lossTriggerRT?.message, "loss");
	}

	getLossTriggerEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.lossTriggerRT?.isEnabled, false);
	}

	getWageringTriggerTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.wageringTriggerRT?.topic,
			"wagering-trigger"
		);
	}

	getWageringTriggerMessage() {
		return this.configService.get((x) => x.common.realTimeNotifications?.wageringTriggerRT?.message, "wagering");
	}

	getWageringTriggerEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.wageringTriggerRT?.isEnabled, false);
	}

	getDepositTriggerTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.depositTriggerRT?.topic,
			"deposit-trigger"
		);
	}

	getDepositTriggerMessage() {
		return this.configService.get((x) => x.common.realTimeNotifications?.depositTriggerRT?.message, "deposit");
	}

	getDepositTriggerEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.depositTriggerRT?.isEnabled, false);
	}

	getToolsTriggerTopic() {
		return this.configService.get((x) => x.common.realTimeNotifications?.toolsTriggerRT?.topic, "tools-trigger");
	}

	getToolsTriggerMessage() {
		return this.configService.get((x) => x.common.realTimeNotifications?.toolsTriggerRT?.message, "tools");
	}

	getToolsTriggerEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.toolsTriggerRT?.isEnabled, false);
	}

	isEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.isEnabled, false);
	}

	getKycTriggerEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.kycTriggerRT?.isEnabled, false);
	}

	getKycTriggerTopic() {
		return this.configService.get((x) => x.common.realTimeNotifications?.kycTriggerRT?.topic, "kyc-status-changed");
	}

	getCustomerActionsEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.customerActionsRT?.isEnabled, false);
	}

	getCustomerActionsTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.customerActionsRT?.topic,
			"realtime-customer-actions"
		);
	}

	getBalanceLimitExceededEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.balanceLimitExceededRT?.isEnabled, false);
	}

	getBalanceLimitExceededTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.balanceLimitExceededRT?.topic,
			"customer-wallet-autowithdrawal-initiated"
		);
	}

	getDepositLimitReachedEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.depositLimitReachedRT?.isEnabled, false);
	}

	getDepositLimitReachedTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.depositLimitReachedRT?.topic,
			"customer-deposit-limit-reached"
		);
	}

	getSessionLimitReachedEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.sessionLimitReachedRT?.isEnabled, false);
	}

	getSessionLimitV2Enabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.sessionLimitV2Enabled, false);
	}

	getSessionLimitReachedTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.sessionLimitReachedRT?.topic,
			"customer-session-limit-reached"
		);
	}

	getSessionLimit5NotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.sessionLimitRT?.session5MinNotification,
			"session5minutes"
		);
	}

	getSessionLimit10NotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.sessionLimitRT?.session10MinNotification,
			"session10minutes"
		);
	}

	getSessionLimit15NotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.sessionLimitRT?.session15MinNotification,
			"session15minutes"
		);
	}

	getBetLimitReachedNotification() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.bettingLimitRT?.betLimitReachedNotification,
			"betlimit-reached"
		);
	}

	getBetLimitNotificationTopic() {
		return this.configService.get((x) => x.common.realTimeNotifications?.bettingLimitRT?.topic, "betlimit-reached");
	}

	getBetLimitNotificationEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.bettingLimitRT?.isEnabled, false);
	}

	getPostLoginLimitCheckEnabled() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.sessionLimitRT?.postLoginLimitCheckEnabled,
			false
		);
	}

	getSelfExclusionNotificationTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.selfExclusionNotificationsRT?.topic,
			"selfexclusion-notification"
		);
	}

	getSelfExclusionNotificationEnabled() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.selfExclusionNotificationsRT?.isEnabled,
			false
		);
	}

	getSelfExclusionNotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.selfExclusionNotificationsRT?.message,
			"sira-previous-selfexclusion"
		);
	}

	getSessionExpiryNotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.sessionLimitRT?.sessionExpiryNotification,
			"session-expiry"
		);
	}

	getSession2MinutesSystemNotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.sessionLimitRT?.session2MinSystemNotification,
			"session2minutes-system"
		);
	}

	getSession10MinutesSystemNotificationMessage() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.sessionLimitRT?.session10MinSystemNotification,
			"session10minutes-system"
		);
	}

	getCustomerInteractionsEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.customerInteractionsRT?.isEnabled, false);
	}

	getCustomerInteractionsTimeTriggerEnabled() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.timeTrigger?.isEnabled,
			false
		);
	}

	getCustomerInteractionsTimeTriggerTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.timeTrigger?.topic,
			"time-trigger"
		);
	}

	getCustomerInteractionsToolsTriggerEnabled() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.toolsTrigger?.isEnabled,
			false
		);
	}

	getCustomerInteractionsToolsTriggerTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.toolsTrigger?.topic,
			"tools-trigger"
		);
	}

	getCustomerInteractionsWageringTriggerEnabled() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.wageringTrigger?.isEnabled,
			false
		);
	}

	getCustomerInteractionsWageringTriggerTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.wageringTrigger?.topic,
			"wagering-trigger"
		);
	}

	getCustomerInteractionsLossTriggerEnabled() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.lossTrigger?.isEnabled,
			false
		);
	}

	getCustomerInteractionsLossTriggerTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.lossTrigger?.topic,
			"loss-trigger"
		);
	}

	getCustomerInteractionsDepositTriggerEnabled() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.depositTrigger?.isEnabled,
			false
		);
	}

	getCustomerInteractionsDepositTriggerTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.customerInteractionsRT?.depositTrigger?.topic,
			"deposit-trigger"
		);
	}

	getCustomerMadeDepositEnabled() {
		return this.configService.get((x) => x.common.realTimeNotifications?.customerMadeDepositRT?.isEnabled, false);
	}

	getCustomerMadeDepositTopic() {
		return this.configService.get(
			(x) => x.common.realTimeNotifications?.customerMadeDepositRT?.topic,
			"customer-made-deposit"
		);
	}
}
